export enum PassportGroupStatusEnum {
  DRAFT = 'DRAFT',
  CANCELLATION_BY_KNO = 'CANCELLATION_BY_KNO',
  WAITING_ACTION = 'WAITING_ACTION',
}
